module.exports = __webpack_public_path__ + "static/img/9.09340bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/zh/9.png
// module id = r/td
// module chunks = 0